import { Spinner } from 'components/Spinner';
import * as React from 'react';
import styled from 'styled-components';

interface IProps {
	text?: string;
	spinner?: boolean;
	onClick?: any;

	background?: string;
	color?: string;
	speed?: string;
	zIndex?: number;
	spinnerSize?: string;
	pointerEventsNone?: boolean;
}

class LoadingOverlay extends React.Component<IProps, any> {
	public render() {
		const Overlay = styled.div`
			position: absolute;
			height: 100%;
			width: 100%;
			top: 0px;
			left: 0px;
			background: ${this.props.background};
			color: ${this.props.color};
			transition: opacity ${this.props.speed}ms ease-out;
			display: flex;
			text-align: center;
			font-size: 1.2em;
			z-index: ${this.props.zIndex};
			&._loading-overlay-transition-appear,
			&._loading-overlay-transition-enter {
				opacity: 0.01;
			}
			&._loading-overlay-transition-appear._loading-overlay-transition-appear-active,
			&._loading-overlay-transition-enter._loading-overlay-transition-enter-active {
				opacity: 1;
				transition: opacity 0.5s ease-in;
			}
			&._loading-overlay-transition-leave {
				opacity: 1;
			}
			&._loading-overlay-transition-leave._loading-overlay-transition-leave-active {
				opacity: 0;
				transition: opacity 0.1s ease-in;
			}
			${(this.props.pointerEventsNone && 'pointer-events:none;') || ''}
		`;

		const Content = styled.div`
			margin: auto;
			color: #000;
			font-size: 14px;
			font-family: 'IBMPlexSans', sans-serif;
		`;

		let spinnerNode = null;
		if (this.props.spinner) {
			spinnerNode = <Spinner />;
		}

		let textNode = null;
		if (this.props.text) {
			textNode = <div>{this.props.text}</div>;
		}

		let contentNode = null;
		if (this.props.text || this.props.spinner) {
			contentNode = (
				<Content>
					{spinnerNode}
					{textNode}
				</Content>
			);
		}

		return (
			<Overlay key="dimmer" onClick={this.props.onClick}>
				{contentNode}
			</Overlay>
		);
	}
}

export { LoadingOverlay };
